<template>
    <span :class="productAvailabilityContainerClass" v-if="showStockDisplay">
        {{ productAvailability }}
    </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    /*  Attribute Values
            1 - Show: On Hand Quantity
            2 - Show: On Hand Quantity/Out oF Stock
            3 - Show: Available/Out of Stock
            4 - Hide On Hand
            5 - Hide Stock Check Button
    */
    props: {
        stockQuantity: {
            type: Number,
            required: true
        },
        backordered: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'customerIndicator',
            // 'userAttributes'
            'storefrontAttributes'
        ]),
        showStockDisplay() {
            let result = true;
            // let obj = this.userAttributes.find(attribute => attribute.type === 'OHQ');
            let obj = this.storefrontAttributes.find(attribute => attribute.indicator === this.customerIndicator && attribute.type === 'OHQ');
            if (obj != undefined) {
                if (obj.value === '1' || obj.value === '2' || obj.value === '3') {
                    result = true;
                } else {
                    result = false;
                }
            }

            return result;
        },
        productAvailability() {
            let availability = 'Undefined';

            if (this.backordered) {
                availability = 'Backordered';
            } else {
                // let obj = this.userAttributes.find(attribute => attribute.type === 'OHQ');
                let obj = this.storefrontAttributes.find(attribute => attribute.indicator === this.customerIndicator && attribute.type === 'OHQ');

                if (obj != undefined) {
                    switch(obj.value) {
                    case '1': 
                        availability = this.stockQuantity;
                        break;
                    case '2':
                        if (parseInt(this.stockQuantity) > 0) {
                            availability = this.stockQuantity;
                        } else {
                            availability = 'Currently Unavailable';
                        }
                        break;
                    case '3':
                        if (parseInt(this.stockQuantity) > 0) {
                            availability = 'Available';
                        } else {
                            availability = 'Currently Unavailable';
                        }
                        break;
                    default:
                        break;
                    }
                }
            }

            return availability;
        },
        productAvailabilityContainerClass() {
            let classtext = 'text-currently-unavailable';

            if (!this.backordered) {
                let obj = this.storefrontAttributes.find(attribute => attribute.indicator === this.customerIndicator && attribute.type === 'OHQ');

                if (obj != undefined) {
                    switch(obj.value) {
                        case '1': 
                            if (this.stockQuantity > 0) {
                                classtext = 'text-available';
                            }
                            break;
                        case '2':
                            if (this.stockQuantity > 0) {
                                classtext = 'text-available';
                            } else {
                                classtext = 'text-currently-unavailable';
                            }
                            break;
                        case '3':
                            if (this.stockQuantity > 0) {
                                classtext = 'text-available';
                            } else {
                                classtext = 'text-currently-unavailable';
                            }
                            break;
                        default:
                            break;
                    }
                } 
            }
        
            return classtext;
        }
    }
}
</script>